import { actions } from './action'

const initialState = {
  rosterList: [],
  totalCount: 0,
  pagination: {
    skip: 0,
    limit: 10,
  },
  year: new Date().getFullYear(),
  searchEmp: null,
  month: new Date().toLocaleString('en-US', { month: 'short' }).toLowerCase(),
}

const roster = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_ROSTER_LIST:
      return {
        ...state,
        rosterList: action.payload.rosterList,
        totalCount: action.payload.totalCount,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.HANDEL_ROSTER_YEAR:
      return {
        ...state,
        year: action.payload,
      }
    case actions.HANDEL_ROSTER_EMP_SEARCH:
      return {
        ...state,
        searchEmp: action.payload,
      }
    case actions.HANDEL_ROSTER_MONTH:
      return {
        ...state,
        month: action.payload,
      }
    default:
      return state
  }
}
export default roster
